export default "__VITE_ASSET__D4IEaAtP__"